var _defs, _rect, _path, _polygon, _path2, _path3, _polygon2, _polygon3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 254.98 298.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 249.26,
    y1: 288.34,
    x2: 208.34,
    y2: 172.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7948ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa2ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 194.8,
    y1: 309.05,
    x2: 156.29,
    y2: 200.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 238.67,
    y1: 214.72,
    x2: 197.96,
    y2: 288.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 134.7,
    y1: 256,
    x2: 136.74,
    y2: 297.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 146.83,
    y1: 247.2,
    x2: 163.71,
    y2: 207.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 194.44,
    y1: 211.29,
    x2: 195.17,
    y2: 250.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 199.67,
    y1: 255.59,
    x2: 176.35,
    y2: 326,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 34.99,
    y1: 152.49,
    x2: 205.16,
    y2: 152.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 112.4,
    y1: 147.79,
    x2: 157.06,
    y2: 147.79,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Avatar-cover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 210.92,
    y: 196.59,
    width: 18.07,
    height: 18.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229,221.88v55.4a6,6,0,0,1-6,6h-9.48a6.05,6.05,0,0,1-4.25-1.76L203.7,276v7.3H185.63V258h.08l0,0,0,0V258H150.26l-11.6,25.29H120.6L132.19,258,140.47,240l15-32.69,3.28-7.16a6,6,0,0,1,5.47-3.51h33.48a6,6,0,0,1,6,6V240h-.29l-4.58-4.59-2.68-2.68H185.92l-.29-.29V214.65h-15.5l-1.22,2.65L158.54,240H190.7a6,6,0,0,1,4.26,1.76l16,16v-35.8Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "228.99 221.88 228.99 275.74 210.92 257.68 210.92 221.88 228.99 221.88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.26,258l-11.6,25.29H120.6l9.67-21.09a7.18,7.18,0,0,1,6.53-4.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M168.91,217.3,158.54,240H145a2.94,2.94,0,0,1-2.67-4.16l13.08-28.53H161Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "203.7 214.65 203.7 239.95 203.41 239.95 198.83 235.36 196.15 232.68 192.06 232.68 192.06 232.68 185.92 232.68 185.63 232.39 185.63 214.65 203.7 214.65"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "203.7 276 203.7 283.3 185.63 283.3 185.63 258.1 185.66 258.01 185.67 257.97 185.71 258.01 203.7 276"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M204.07,36.35a10.34,10.34,0,0,0-.39-1.55c-7.94-24.4-35.54-18.59-49.42-2.35-14.7,16.71-37.88,14.61-56.69,6.69a11.39,11.39,0,0,1-1-.52C51.39,13.49,29.41,59.49,41.14,98.91c3.1,12.28,8.77,23.64,15.17,34.51,9.26,14.58,2.21,17.28-9.92,12.74a10.16,10.16,0,0,0-7.32-.07c-12.24,4.94,13,25.49,18.84,30.63,11.61,10,17.14,25.69,12.32,40.5-2.84,11.52-10.11,23-21.84,26.69a11.77,11.77,0,0,1-2.13.4c-13.42,1.52-13.92,15.4-6.39,24.47A11.61,11.61,0,0,0,41.08,270c67,58.57,106.14-52.52,66.53-102.75-11.7-18-30.7-30.62-39.52-50.53-5.71-11.58-5.68-29,5.65-37.19,8-5.1,26.4,4.68,34.67,8.51a7.24,7.24,0,0,1,.68.35C152.17,113.25,214.16,92.43,204.07,36.35Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M132.88,124.89c-26.35,4.25-28.64,46.15,1.17,46.07C164.48,170.51,165.38,120.42,132.88,124.89Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.43df5e4354ec0d6c335f048c2e22e3a8.svg";
export { ForwardRef as ReactComponent };